<template>
    <div class="stats-inner-box" 
      @click="clickHover"
      @mouseover="isHovering = true" @mouseout="isHovering = false" :class="{'hover' : hover && isHovering}" :style="{'background-color': background_color , 'border' : `1px solid ${border_color}` , 'color' : text_color}">
        <div class="row" style="height: 100%">
            <div class="col-8">
              <p>{{title}}</p>
              <p class="stats-value">
                {{ !value.includes('NaN') ? value : 0 }}
                <span
                    v-if="sub_value != null"
                    class="stats-value-support"
                    style="font-size:14px;"
                >({{!sub_value.includes('NaN') ? sub_value : 0 }})</span>
              </p>
            </div>
            <div class="col-4 icon" v-if="icon">
              <i class="fas" :class="['fa-'+icon]"></i>
            </div>
            <div class="col-4 icon" v-else-if="chart">

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
              isHovering : false
            }
        },
        props : ['title', 'value', 'sub_value', 'icon', 'background_color', 'text_color' , 'border_color', 'align' , 'chart' , 'hover'],
        mounted () {
          this.text_color = this.text_color ? this.text_color : '#000'
          this.border_color = this.border_color ? this.border_color : '#000'
          this.align = this.align ? this.align : 'left'
        },
        methods : {
          clickHover() {
            this.$emit('emitClick')
          }
        }
    }
</script>

<style scoped>

  .hover {
    color : white;
    background-color: black !important;
    cursor : pointer;
  }
  .stats-outer-box{
    padding:20px;
  }

  .stats-inner-box{
    border-radius: 10px;
    background-color: #348FE2;
    height: 100%;
    /* padding-bottom:10px */
  }

  /* .stats-inner-box p, .stats-inner-box h2{
    color: white;
  } */
  .stats-inner-box p{
    margin:5% 0 0 12.5%;
  }
  .stats-inner-box .stats-value{
    margin-top: 0;
    margin-left:10%;
    margin-bottom:10px;
    font-size: 2em;
    font-weight: 500;
  }
  .stats-inner-box .stats-value .stats-value-support{
    font-size: 0.5em;
    font-weight: normal;
  }
  .stats-inner-box h2{
    margin-left:10%
  }
  .stats-inner-box .icon{
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .stats-inner-box .icon i{
    color: #00000050;
    font-size: 3em;
  }
</style>